import React from 'react';

interface MetricsProps {
  netRevenue: number;
  totalFund: number;
  valuePerShare: number;
  totalShares: number;
  finalTitan: number;
  titanPrice: number;
}

export const GlobalMetrics: React.FC<MetricsProps> = ({
  netRevenue,
  totalFund,
  valuePerShare,
  totalShares,
  finalTitan,
  titanPrice
}) => {
  const formatCurrency = (val: number) => 
    new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 }).format(val);

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
      {/* Net Revenue */}
      <div className="bg-white rounded-xl shadow-sm p-6 border-l-4 border-blue-500 transition-transform duration-200 hover:-translate-y-1 hover:shadow-md">
        <div className="flex justify-between items-start">
          <div>
            <p className="text-sm font-medium text-gray-500 mb-1">Net Revenue Toàn Hệ Thống</p>
            <h3 className="text-2xl font-bold text-gray-800">{formatCurrency(netRevenue)}</h3>
          </div>
          <div className="p-3 bg-blue-50 rounded-lg text-blue-500">
            <i className="fas fa-globe fa-lg"></i>
          </div>
        </div>
        <div className="mt-4 flex items-center text-sm">
          <span className="text-green-500 flex items-center font-medium">
            <i className="fas fa-arrow-up mr-1"></i> 5.2%
          </span>
          <span className="text-gray-400 ml-2">so với tháng trước</span>
        </div>
      </div>

      {/* Total Fund */}
      <div className="bg-white rounded-xl shadow-sm p-6 border-l-4 border-amber-500 transition-transform duration-200 hover:-translate-y-1 hover:shadow-md">
        <div className="flex justify-between items-start">
          <div>
            <p className="text-sm font-medium text-gray-500 mb-1">Tổng Quỹ Titan+Pioneer (8%)(8%)</p>
            <h3 className="text-2xl font-bold text-gray-800">{formatCurrency(totalFund)}</h3>
          </div>
          <div className="p-3 bg-amber-50 rounded-lg text-amber-500">
            <i className="fas fa-piggy-bank fa-lg"></i>
          </div>
        </div>
        <div className="mt-4 text-xs text-gray-500">Công thức: Net Revenue × 8%</div>
      </div>

      {/* Value per share */}
      <div className="bg-white rounded-xl shadow-sm p-6 border-l-4 border-purple-500 transition-transform duration-200 hover:-translate-y-1 hover:shadow-md">
        <div className="flex justify-between items-start">
          <div>
            <p className="text-sm font-medium text-gray-500 mb-1">Giá Trị 1 Phần</p>
            <h3 className="text-2xl font-bold text-gray-800">{formatCurrency(valuePerShare)}</h3>
          </div>
          <div className="p-3 bg-purple-50 rounded-lg text-purple-500">
            <i className="fas fa-chart-pie fa-lg"></i>
          </div>
        </div>
        <div className="mt-4 text-xs text-gray-500">
          Tổng số phần: <span className="font-bold">{totalShares.toLocaleString()}</span> phần
        </div>
      </div>

      {/* My Package Info */}
      <div className="bg-[#1e3a8a] rounded-xl shadow-md p-6 text-white relative overflow-hidden transition-transform duration-200 hover:-translate-y-1 hover:shadow-md">
        <div className="absolute top-0 right-0 -mt-4 -mr-4 w-24 h-24 bg-white opacity-10 rounded-full blur-xl"></div>
        <div className="absolute bottom-0 left-0 -mb-4 -ml-4 w-16 h-16 bg-amber-500 opacity-20 rounded-full blur-lg"></div>
        <div className="relative z-10">
          <div className="flex justify-between items-center mb-4">
            <p className="text-sm font-medium text-blue-200">Gói Đầu Tư Của Bạn</p>
            <span className="px-2 py-1 bg-amber-500 text-[#1e3a8a] text-xs font-bold rounded uppercase">Kích hoạt</span>
          </div>
          <h3 className="text-2xl font-bold mb-1">Titan</h3>
          <p className="text-blue-200 text-sm mb-4">Trị giá: <span className="font-bold text-white">{formatCurrency(titanPrice)}</span></p>
          <div className="border-t border-blue-700 pt-3">
            <div className="flex justify-between items-center">
              <span className="text-sm text-blue-200">Dự kiến nhận tháng này</span>
              <span className="text-lg font-bold text-amber-400">{formatCurrency(finalTitan)}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};